import React from "react";
import BasaksehirSidebar from "../Sidebar/BasaksehirSidebar";
import BasaksehirOtherServices from "../ServiceAreas/BasaksehirServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const BasaksehirIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        BAKIRKÖY HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Bakırköy'de halı ve koltuklarınız için özel çözümler sunuyoruz. Hijyenik, hızlı ve güvenilir yıkama hizmetlerimiz sayesinde evinizdeki tüm tekstil ürünleri ilk günkü temizliğine kavuşur. Profesyonel ekibimiz, her kumaş türüne özel ekipmanlar ve yöntemlerle temizlik yapar.
          </p>

          <p>
            Halılarınız, tam otomatik makinelerde yıkanmadan önce detaylı bir toz alma işlemine tabi tutulur. Koltuklarınız ise yerinde veya fabrikada buharlı sistemlerle, kumaşa zarar vermeyecek şekilde temizlenir. Temizlikte yalnızca organik ve cilt dostu ürünler kullanılır.
          </p>

          <p>
            <strong>Bakırköy halı ve koltuk yıkama hizmetimizin avantajları:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Ücretsiz servis: Adresten alım ve teslimat</li>
            <li>Fabrikada veya yerinde koltuk yıkama seçenekleri</li>
            <li>Koku giderici ve antibakteriyel uygulamalar</li>
            <li>Hassas kumaşlara özel temizlik çözümleri</li>
            <li>Leke çıkarma garantili profesyonel müdahale</li>
            <li>48 saat içinde teslim garantisi</li>
          </ul>

          <p>
            Zuhuratbaba, Kartaltepe, Osmaniye, Yenimahalle, Cevizlik, Şenlikköy, Yeşilköy, Yeşilyurt ve Ataköy mahallelerinde aktif servis ağımızla aynı gün alım-teslim hizmeti sunuyoruz. Profesyonel ve güler yüzlü ekibimizle hızlı ve kaliteli hizmet alırsınız.
          </p>

          <p>
            Bakırköy’de halı ve koltuk temizliğinde güvenilir bir firma arıyorsanız doğru adrestesiniz. Hemen web sitemiz üzerinden sipariş oluşturabilir ya da iletişim bilgilerimizden bize ulaşabilirsiniz.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <BasaksehirSidebar />
          <BasaksehirOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default BasaksehirIntro;
